export const PROTOCOL_LABELS = { udp: 'UDP', tcp: 'TCP', both: 'UDP e TCP' };

export const DESTINATION_PORTS = ['5060', '5061'];

export const EMPTY_FORM = {
  sourceIp: '',
  sourcePortStart: '',
  sourcePortEnd: '',
  protocol: 'both',
  destinationPort: '5060',
};

export const PORT_REDIRECT_MESSAGES = {
  empty: 'Nenhuma regra de redirect cadastrada',
  noMatch: 'Nenhuma regra encontrada',
  notApplied: 'Não aplicada',
  loadFailed: 'Erro ao carregar as regras de redirect.',
  saveFailed: 'Erro ao salvar a regra de redirect.',
  deleteFailed: 'Erro ao excluir a regra de redirect.',
  help: 'No ramal, use <IP do servidor>:<porta de origem> como servidor de registro e como proxy de saída (outbound proxy).',
};

const CODE_MESSAGES = {
  RULE_OVERLAP: 'Já existe uma regra com porta de origem e protocolo sobrepostos. Exclua a regra existente ou escolha outra porta.',
  RULE_LIMIT_REACHED: 'Limite de 50 regras de redirect atingido. Exclua uma regra antes de adicionar outra.',
  PORT_CHECK_UNAVAILABLE: 'Não foi possível verificar as portas em uso no servidor. Tente novamente.',
  LOCK_TIMEOUT: 'Outra alteração de redirect está em andamento. Tente novamente em instantes.',
  APPLY_FAILED: 'O servidor não conseguiu aplicar a regra. Nenhuma alteração foi feita.',
  PERSIST_FAILED: 'O servidor não conseguiu salvar a regra. Nenhuma alteração foi feita.',
  STORE_CORRUPTED: 'O arquivo de regras do servidor está inválido. Acione o suporte.',
  RATE_LIMITED: 'Muitas alterações de redirect de portas. Aguarde 1 minuto.',
};

const CODES_WITH_SERVER_DETAIL = ['VALIDATION_ERROR', 'PORT_RESERVED', 'PORT_IN_USE'];

export const formatSourceIp = (rule) => rule.sourceIp || 'Qualquer';

export const formatSourcePorts = (rule) => (rule.sourcePortStart === rule.sourcePortEnd
  ? String(rule.sourcePortStart)
  : `${rule.sourcePortStart}–${rule.sourcePortEnd}`);

export const formatProtocol = (protocol) => PROTOCOL_LABELS[protocol] || '';

export const toRow = (rule) => ({
  id: rule.id,
  sourceIp: formatSourceIp(rule),
  sourcePorts: formatSourcePorts(rule),
  protocol: formatProtocol(rule.protocol),
  destinationPort: String(rule.destinationPort),
  applied: rule.applied !== false,
});

const searchableTexts = (row) => [row.sourceIp, row.sourcePorts, row.protocol, row.destinationPort];

export const filterRules = (rules, term) => {
  const needle = String(term || '').trim().toLowerCase();
  if (!needle) return rules;
  const port = /^\d+$/.test(needle) ? Number(needle) : null;
  return rules.filter((rule) => {
    const matchesText = searchableTexts(toRow(rule)).some((text) => text.toLowerCase().includes(needle));
    const insideRange = port !== null && port >= rule.sourcePortStart && port <= rule.sourcePortEnd;
    return matchesText || insideRange;
  });
};

export const errorMessageFor = (result, fallback) => {
  if (!result) return fallback;
  if (CODES_WITH_SERVER_DETAIL.includes(result.code) && result.error) return result.error;
  if (CODE_MESSAGES[result.code]) return CODE_MESSAGES[result.code];
  return result.error || fallback;
};

const toPortValue = (value) => {
  const text = String(value === undefined || value === null ? '' : value).trim();
  if (text === '') return undefined;
  return /^\d+$/.test(text) ? Number(text) : text;
};

export const buildPayload = (form) => {
  const payload = {
    sourceIp: String(form.sourceIp || '').trim(),
    sourcePortStart: toPortValue(form.sourcePortStart),
    protocol: form.protocol || EMPTY_FORM.protocol,
    destinationPort: Number(form.destinationPort || EMPTY_FORM.destinationPort),
  };
  const sourcePortEnd = toPortValue(form.sourcePortEnd);
  if (sourcePortEnd !== undefined) payload.sourcePortEnd = sourcePortEnd;
  if (payload.sourcePortStart === undefined) delete payload.sourcePortStart;
  return payload;
};
